import { lighten, transparentize } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  .SKY_LGPD_theme {
    width: 25px;
    position: absolute;
    z-index: 9999;
    right: 285px;
    border-radius: 50%;
    height: 25px;
    top: 14px;

    svg {
      position: absolute;
      top: 5px;
      right: 4px;
      color: ${props => props.theme.colors.primaryText};
    }

    background: ${transparentize(0.9, '#000')};

    &:hover {
      background: ${props => lighten(0.05, props.theme.colors.thirdBackground)};
      cursor: pointer;
    }
  }
`;

export const ContentWrapper = styled.div`
  background: ${props => props.theme.colors.primaryBackground};
  padding: 0 20px;

  .section-layout {
    padding-bottom: 50px;
  }

  .footer-link {
    position: absolute;
    bottom: 0;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-top: 1px solid ${props => props.theme.colors.secondaryText};
    color: ${props => props.theme.colors.secondaryText};

    .faq,
    .política-privacidade {
      font-size: 14px;
      color: ${props => props.theme.colors.secondaryText};
    }

    .política-privacidade {
      margin-right: 15px;
    }

    .faq {
      margin-left: 15px;
    }
  }
`;
